import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
} from "@angular/core";
// import { Subscription } from "rxjs";
import { PharmaDataService } from "../pharma-data.service";
import { ActivatedRoute } from "@angular/router";
import { getSelectedPeriods } from "src/app/utils/period-utils";
import { Observable, Subscription } from "rxjs";
import { AppService } from "src/app/app.service";
import { GlobalSubheaderDataService } from "src/app/global-subheader/global-subheader-data.service";

// import { INIT } from "@ngrx/store";
// import { fal } from "@fortawesome/pro-light-svg-icons";

@Component({
  selector: "app-drug-distribution-analysis",
  templateUrl: "./drug-distribution-analysis.component.html",
  styleUrls: ["./drug-distribution-analysis.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DrugDistributionAnalysisComponent implements OnInit {
  @Input() activeTab;
  isLoading = true;
  switchValue = true;
  brokersSwitchValue = true;
  isExcluded: boolean;
  dataObservable: Observable<any>;
  routeSubscriber: Subscription;
  defaultFilterCall: Subscription;
  cTagId;
  sourceMeta;
  dataCall;
  sourceCall;
  reaffirmCall;
  excludedSource = [];
  includedSource = [];
  brokerList;
  datacallParms;
  reaffirmParams;
  params;
  periodRange = [-2, 7];
  selectedCurrency = "Base";
  filterId;
  isTabViewed = false;
  dataView: { view_by: any[]; revision: string } = {
    view_by: ["values"],
    revision: "",
  };
  brokerGridCount = -1;

  customSkeletonConfig = {
    skeletonType: "grid",
    config: {
      grid: {
        count: {
          row: 10,
          column: 1,
        },
        bordered: true,
      },
    },
  };

  defaultPeriodObj = {
    is_annual_selected: true,
    period_basis: {
      abs: {
        from_basis: [
          {
            label: "",
            name: "Y",
            selected: true,
          },
        ],
        to_basis: [
          {
            label: "",
            name: "Y",
            selected: true,
          },
        ],
      },
      rel: {
        from_basis: [
          {
            label: "",
            name: "Y",
            selected: false,
          },
        ],
        to_basis: [
          {
            label: "",
            name: "Y",
            selected: false,
          },
        ],
      },
    },
    basis: [
      {
        label: "Calendar",
        name: "cal",
        selected: false,
      },
      {
        label: "Fiscal",
        name: "fy",
        selected: true,
      },
    ],
    from_to: {
      selected_from: new Date().getFullYear() - 2,
      selected_to: new Date().getFullYear() + 7,
    },
    other_period: [],
    type: [
      {
        label: "Absolute",
        name: "abs",
        selected: true,
      },
      {
        label: "Relative",
        name: "rel",
        selected: false,
      },
    ],
  };
  defaultPeriodObjCopy = {
    is_annual_selected: true,
    period_basis: {
      abs: {
        from_basis: [
          {
            label: "",
            name: "Y",
            selected: true,
          },
        ],
        to_basis: [
          {
            label: "",
            name: "Y",
            selected: true,
          },
        ],
      },
      rel: {
        from_basis: [
          {
            label: "",
            name: "Y",
            selected: false,
          },
        ],
        to_basis: [
          {
            label: "",
            name: "Y",
            selected: false,
          },
        ],
      },
    },
    basis: [
      {
        label: "Calendar",
        name: "cal",
        selected: false,
      },
      {
        label: "Fiscal",
        name: "fy",
        selected: true,
      },
    ],
    from_to: {
      selected_from: new Date().getFullYear() - 2,
      selected_to: new Date().getFullYear() + 7,
    },
    other_period: [],
    type: [
      {
        label: "Absolute",
        name: "abs",
        selected: true,
      },
      {
        label: "Relative",
        name: "rel",
        selected: false,
      },
    ],
  };
  defaultPeriodSubscriber: Subscription;
  onPharmaExcelExportSubscriber: Subscription;
  acessibilityToggle: boolean = false;
  dataSettings = {
    currency: "",
    periodData: {
      period: getSelectedPeriods(this.defaultPeriodObj, false),
      periodStart: -2,
      periodEnd: 7,
      period_type: "absolute",
      period_basis: "fiscal",
    },
    view_by: ["values"],
    revision: "",
    revisionDate: "",
  };
  defaultDataSettings = {
    currency: "",
    periodData: {
      period: getSelectedPeriods(this.defaultPeriodObj, false),
      periodStart: -2,
      periodEnd: 7,
      period_type: "absolute",
      period_basis: "fiscal",
    },
    view_by: ["values"],
    revision: "",
    revisionDate: "",
  };
  metaReady = false;
  @Output() downloadPharmaExcel: EventEmitter<any> = new EventEmitter<any>();
  showResearchPopup: boolean = false;
  @Input() drugResearchParameters: any[] = [];
  sourceOrgDict = {};
  isDSMParameterAPIInvoke: boolean = false;
  currentDapObj: any;
  onSelectedLineItemSubscriber: Subscription;
  drug_dapparameterid: number = 0;
  ticker: string;
  showPOS: boolean;
  constructor(
    private dataService: PharmaDataService,
    private appService: AppService,
    private route: ActivatedRoute,
    private globalHeaderDataService: GlobalSubheaderDataService,
  ) {}

  cascaderValue: any;
  selectedLIValue = {
    value: undefined,
    label: undefined,
    prefixIcon: undefined,
  };

  // onCascaderValueChange(value: any) {
  //   this.cascaderValue = value;
  //   this.selectedLIValue = value?.[0];
  //   this.makeSourcesMetaCall();
  //   this.persistFilter();
  // }
  ngOnInit() {
    this.routeSubscriber = this.route.params.subscribe((param) => {
      try {
        if (param.cTagId) {
          this.cTagId = parseInt(param.cTagId);
          this.params = {
            ctagid: this.cTagId,
            period_basis: "calendar",
            viewby: "values",
            revision: "",
          };
        } else {
          console.error("Ctagid is mandatory in route param");
        }
      } catch (e) {
        console.error("Invalid ctagid ", e);
      }
    });
    this.filterId = null;
    this.onSelectedLineItemSubscriber =
      this.dataService.selectedLineItem.subscribe((value) => {
        this.selectedLIValue = value;
        this.makeSourcesMetaCall();
        this.persistFilter();
      });
    this.onPharmaExcelExportSubscriber =
      this.globalHeaderDataService.onPharmaExcelExport.subscribe(() => {
        const params = {
          ctagid: this.cTagId,
          currency: this.dataSettings.currency,
          viewby: this.dataSettings.view_by[0],
          revision: this.dataSettings.revision,
          period: this.dataSettings.periodData.period,
          period_type: this.dataSettings.periodData.period_type,
          period_basis: this.dataSettings.periodData.period_basis,
          dpid:
            this.selectedLIValue && this.selectedLIValue["value"]
              ? this.selectedLIValue["value"]
              : null,
        };
        if (this.activeTab === 1) this.downloadPharmaExcel.emit(params);
      });
    this.dataService.pharmaDSMAccessCheck.subscribe(() => {
      this.getDrugReasearchParameters();
    });
  }

  getAccessiblityToggleValue(value) {
    this.acessibilityToggle = value;
    this.persistFilter();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      changes &&
      changes.activeTab &&
      changes.activeTab.currentValue &&
      changes.activeTab.currentValue === 1
    ) {
      if (!this.isTabViewed) {
        this.isTabViewed = true;
        this.getRevisionDate();
        this.makeDefaultFilterCall();
        this.dataService.logUserAction(
          "DEFAULT_PAGE_LOAD",
          {
            dataSettings: this.dataSettings,
            drugCtag: this.cTagId,
          },
          "BIOPHARMA_DISTRIBUTION_PAGE",
        );
      }
    }
  }

  onDataSourceChanged(count) {
    this.brokerGridCount = count;
    this.getDrugReasearchParameters();
  }

  makeDefaultFilterCall() {
    this.isLoading = true;
    this.defaultFilterCall = this.dataService
      .getDistributionPageFilterData(this.cTagId)
      .subscribe((defaultData: any) => {
        if (defaultData.status === "success") {
          if (
            defaultData.data &&
            defaultData.data.length &&
            defaultData.data[0].json_data &&
            Object.keys(defaultData.data[0].json_data).length
          ) {
            //have saved data
            const filterObj = defaultData.data[0];
            if (defaultData.data[0].json_data["deleted"]) {
              this.filterId = filterObj.filter_id;
              this.makeDefaultPeriodCall(this.cTagId);
            } else {
              this.filterId = filterObj.filter_id;
              this.dataSettings = { ...filterObj.json_data.dataSettings };
              this.periodRange = [
                this.dataSettings.periodData.periodStart - 1,
                this.dataSettings.periodData.periodEnd - 1,
              ];
              this.defaultPeriodObj = {
                ...filterObj.json_data.defaultPeriodObj,
              };
              this.selectedCurrency =
                this.dataSettings.currency === ""
                  ? "Base"
                  : this.dataSettings.currency;
              this.brokersSwitchValue = filterObj.json_data.brokersSwitchValue;
              // this.selectedLIValue = filterObj.json_data.selectedLineItem ?? {};
              this.dataService.selectedLineItem.next(
                filterObj.json_data.selectedLineItem ?? {},
              );
              this.acessibilityToggle = filterObj.json_data.acessibilityToggle;
              this.makeSourcesMetaCall();
            }
          } else {
            //no saved data
            this.makeDefaultPeriodCall(this.cTagId);
          }
        } else {
          console.error("Error while fetching default filter data");
        }
      });
  }

  onFilterReset() {
    this.isLoading = true;
    if (this.filterId) {
      const payload = {
        filter_id: this.filterId,
        filter_name: this.cTagId,
        json_data: { deleted: true },
        page_name: "distribution",
      };
      this.dataService.updateFilterObject(payload).subscribe();
    }
    this.defaultPeriodObj = this.appService.superClone(
      this.defaultPeriodObjCopy,
    );
    this.dataSettings = this.appService.superClone(this.defaultDataSettings);
    this.selectedCurrency = "Base";
    this.cascaderValue = undefined;
    this.selectedLIValue = {
      value: undefined,
      label: undefined,
      prefixIcon: undefined,
    };
    this.dataService.selectedLineItem.next({
      value: undefined,
      label: undefined,
      prefixIcon: undefined,
    });
    this.brokersSwitchValue = true;
    this.dataView = {
      view_by: ["values"],
      revision: "",
    };
    this.makeDefaultPeriodCall(this.cTagId);
    this.dataService.logUserAction(
      "GRID_SETTINGS_RESET",
      {
        drugCtag: this.cTagId,
      },
      "BIOPHARMA_DISTRIBUTION_PAGE",
    );
  }

  makeSourcesMetaCall() {
    this.isLoading = true;
    this.isExcluded = false;
    this.params = {
      ctagid: this.cTagId,
      period_basis: this.dataSettings.periodData.period_basis,
      viewby: this.dataSettings.view_by[0],
      revision: this.dataSettings.revision,
      dpid:
        this.selectedLIValue && this.selectedLIValue["value"]
          ? this.selectedLIValue["value"]
          : null,
    };

    this.sourceMeta = this.dataService
      .getDistributionPageSourcesData(this.params)
      .subscribe((resp) => {
        this.sourceCall = resp;
        this.includedSource = [];
        this.excludedSource = [];
        if (resp["broker_data"]) {
          resp["broker_data"].forEach((item) => {
            if (item.excluded) {
              this.excludedSource.push(item["id"]);
            } else {
              this.includedSource.push(item["id"]);
            }
          });
        }
        this.datacallParms = {
          ctagid: this.cTagId,
          currency: this.dataSettings.currency,
          period: this.dataSettings.periodData.period,
          period_basis: this.dataSettings.periodData.period_basis,
          period_type: this.dataSettings.periodData.period_type,
          revision: this.dataSettings.revision,
          viewby: this.dataSettings.view_by[0],
          include_sources: this.includedSource,
          exclude_sources: this.excludedSource,
          dpid:
            this.selectedLIValue && this.selectedLIValue["value"]
              ? this.selectedLIValue["value"]
              : null,
        };

        this.reaffirmParams = {
          included_sources: this.includedSource,
          ctagid: this.cTagId,
        };

        this.makeDataCall();
        this.setReaffirmFlag();
      });
  }

  makeDataCall() {
    this.isLoading = true;
    this.dataService
      .getDistributionPageData(this.datacallParms)
      .subscribe((resp) => {
        this.dataCall = resp;
        this.brokerGridCount = this.dataCall.sorted_ids.length;
        [...resp["sorted_ids"], "13001"].forEach((brokerId) => {
          //custom object with all broker data from sorted ids and consensus
          // brokerWithConsensus[brokerId] = resp[brokerId];
          //excluded label logic
          if (resp[brokerId] && resp[brokerId].exclude === true) {
            this.isExcluded = true;
          }
          if (resp[brokerId] && resp[brokerId]) {
            this.showPOS =
              Object.keys(resp[brokerId]["meta"]).indexOf("pos") !== -1;
          }
        });
        if ("meta" in this.dataCall && "dpid" in this.dataCall.meta) {
          this.drug_dapparameterid = this.dataCall.meta.dpid;
        }
      });
    this.isLoading = false;
  }

  setReaffirmFlag() {
    this.dataService
      .getDistributionPageReaffirmFlag(this.reaffirmParams)
      .subscribe((resp) => {
        this.reaffirmCall = resp;
      });
  }

  onBrokerSwitchChange(isSwitched: boolean) {
    this.brokersSwitchValue = isSwitched;
    this.persistFilter();
    this.dataService.logUserAction(
      "HIGHLIGHT_HIGH_LOW",
      {
        drugCtag: this.cTagId,
        high_low: isSwitched,
      },
      "BIOPHARMA_DISTRIBUTION_PAGE",
    );
  }

  persistFilter() {
    const _ds = {
      ...this.dataSettings,
      revision: "",
      view_by: ["values"],
    };
    const payload = {
      filter_name: this.cTagId,
      json_data: {
        dataSettings: _ds,
        brokersSwitchValue: this.brokersSwitchValue,
        defaultPeriodObj: this.defaultPeriodObj,
        selectedLineItem: this.selectedLIValue,
        acessibilityToggle: this.acessibilityToggle,
      },
      page_name: "distribution",
    };
    if (this.filterId) {
      payload["filter_id"] = this.filterId;
      this.dataService.updateFilterObject(payload).subscribe();
    } else {
      this.dataService.saveCurrentFilter(payload).subscribe((res) => {
        if (res.status === "success" && res.filter_id) {
          this.filterId = res.filter_id;
        } else {
          console.error("Save filter api failed");
        }
      });
    }
  }

  dataSettingsChanged(dataSettingsObj) {
    this.dataSettings = { ...dataSettingsObj.dataSettings };
    this.defaultPeriodObj = { ...dataSettingsObj.defaultPeriodObj };
    this.getRevisionDate();
    if (dataSettingsObj.filterName !== "dataView") {
      this.persistFilter();
    }
    this.selectedCurrency =
      this.dataSettings.currency === "" ? "Base" : this.dataSettings.currency;
    this.datacallParms = {
      ctagid: this.cTagId,
      currency: this.dataSettings.currency,
      period: this.dataSettings.periodData.period,
      period_basis: this.dataSettings.periodData.period_basis,
      period_type: this.dataSettings.periodData.period_type,
      revision: this.dataSettings.revision,
      viewby: this.dataSettings.view_by[0],
      dpid: this.selectedLIValue["value"]
        ? this.selectedLIValue["value"]
        : null,
      include_sources: this.includedSource,
      exclude_sources: this.excludedSource,
    };
    //Call sources meta only if data/revision filter changes dimension from current to revision and vice versa
    if (
      dataSettingsObj.filterName === "dataView" &&
      (this.dataView.view_by[0] === "revision" ||
        this.dataSettings.view_by[0] === "revision")
    ) {
      this.makeSourcesMetaCall();
    } else {
      this.makeDataCall();
    }
    this.dataView = {
      view_by: [this.dataSettings.view_by[0]],
      revision: this.dataSettings.revision,
    };
    this.dataService.logUserAction(
      "GRID_SETTINGS",
      {
        dataSettings: this.dataSettings,
        drugCtag: this.cTagId,
      },
      "BIOPHARMA_DISTRIBUTION_PAGE",
    );
  }

  makeDefaultPeriodCall(cTagId) {
    this.defaultPeriodSubscriber = this.dataService
      .getDefaultPeriod(cTagId)
      .subscribe((resp: any) => {
        if (resp.status !== "error" && resp.message !== "Data not available") {
          const from = resp.data.from_period;
          const to = resp.data.to_period;

          this.defaultPeriodObj.from_to.selected_from =
            new Date().getFullYear() + from;
          this.defaultPeriodObj.from_to.selected_to =
            new Date().getFullYear() + to;

          this.dataSettings = {
            ...this.dataSettings,
            periodData: {
              ...this.dataSettings.periodData,
              period: getSelectedPeriods(this.defaultPeriodObj, false),
              periodStart: from,
              periodEnd: to,
            },
          };
          this.periodRange = [
            this.dataSettings.periodData.periodStart,
            this.dataSettings.periodData.periodEnd,
          ];
          this.makeSourcesMetaCall();

          this.metaReady = true;
        } else {
          console.error(
            `get_drug_periods returned no data for ctagId: ${cTagId}`,
          );
        }
      });
  }

  getRevisionDate() {
    const revision = this.dataSettings.revision;
    if (revision !== "" || revision !== null) {
      if (revision === "1m" || revision === "3m") {
        const mnths = Number(revision.replace("m", ""));
        const asOfDate = new Date();
        asOfDate.setMonth(asOfDate.getMonth() - mnths);
        this.dataSettings.revisionDate = asOfDate.toLocaleDateString("en-US");
      } else {
        this.dataSettings.revisionDate = revision.replace("custom|", "");
      }
    }
  }
  // this.dataService.logUserAction(
  //   "GRID_SETTINGS",
  //   {
  //     dataSettings: this.dataSettings,
  //     drugCtag: this.cTagId
  //   },
  //   "BIOPHARMA_DRUG_PAGE"
  // );
  ngOnDestroy() {
    if (this.onPharmaExcelExportSubscriber) {
      this.onPharmaExcelExportSubscriber.unsubscribe();
    }
    this.dataService.pharmaDSMAccessCheck.unsubscribe();
    if (this.onSelectedLineItemSubscriber) {
      this.onSelectedLineItemSubscriber.unsubscribe();
    }
  }

  getDrugReasearchParameters() {
    if (
      this.drugResearchParameters.length === 0 &&
      !this.isDSMParameterAPIInvoke &&
      this.dataService.pharmaAccess.hasDSMAccess
    ) {
      this.isDSMParameterAPIInvoke = true;
      const payload = { drugid: this.cTagId };
      this.dataService
        .getPharmaDSMDrugParameters(payload)
        .subscribe((resp: any) => {
          this.drugResearchParameters = resp["data"];
        });
    }
  }

  onResearchIconClick(data) {
    this.currentDapObj = {
      parameterid: data.parameterid,
      drugid: data.drugid,
      brokers: data.brokers,
    };
    this.showResearchPopup = true;
  }

  onResearchIconClickByBroker(data) {
    let orgId = 0;
    if (data.brokers[0] in this.sourceOrgDict) {
      orgId = this.sourceOrgDict[data.brokers[0]];
    }
    this.currentDapObj = {
      parameterid: data.parameterid,
      drugid: data.drugid,
      brokers: [orgId],
    };
    this.showResearchPopup = true;
  }

  hideResearchInsightPopup() {
    this.showResearchPopup = false;
  }

  showResearchParameterOnGrid(dataSource) {
    if (dataSource.length > 0) {
      const reserchParameterList = this.drugResearchParameters.map(
        (x) => x.parameterid,
      );
      for (const index in dataSource) {
        if (
          "name" in dataSource[index] &&
          dataSource[index]["name"] === "Consensus" &&
          reserchParameterList.includes(this.drug_dapparameterid)
        ) {
          dataSource[index]["isResearchIconShow"] = true;
        }
      }
    }
  }

  showResearchParameterOnGridByBroker(dataSource) {
    this.drugResearchParameters.forEach((parameter) => {
      parameter["documents"].forEach((doc) => {
        this.sourceOrgDict[doc["sourceid"]] = doc["orgid"];
      });
    });

    if (dataSource.length > 0) {
      const reserchParameter = this.drugResearchParameters.find(
        (x) => x.parameterid === this.drug_dapparameterid,
      );
      const sourceIds = reserchParameter["documents"].map((x) => x.sourceid);
      for (const index in dataSource) {
        if (
          "src" in dataSource[index] &&
          sourceIds.includes(Number(dataSource[index]["src"]))
        ) {
          dataSource[index]["isResearchIconShow"] = true;
        }
      }
    }
  }
}
